import React from 'react';

import ContractHeadersContainer from '../ContractHeaders/ContractHeaders.container';
import UpliftHeadersContainer from './UpliftHeaders.container';

import styles from './uplift-header.module.scss';

export default function Uplifts() {
  return (
    <>
      <ContractHeadersContainer />
      <div className={styles['uplift-container']}>
        <UpliftHeadersContainer />
      </div>
    </>
  );
}